import { fromEvent, merge, Observable, OperatorFunction } from 'rxjs';
import { HasEventTargetAddRemove } from 'rxjs/internal/observable/fromEvent';
import { operate } from 'rxjs/internal/util/lift';
import { createOperatorSubscriber } from 'rxjs/internal/operators/OperatorSubscriber';

export function fromEvents<T>(
  target: HasEventTargetAddRemove<T> | ArrayLike<HasEventTargetAddRemove<T>>,
  eventNames: string[],
): Observable<T> {
  return merge(...eventNames.map(_ => fromEvent<T>(target, _)));
}

export function filterDefined<T>(): OperatorFunction<T, NonNullable<T>> {
  return operate((source, subscriber) => {
    source.subscribe(createOperatorSubscriber(subscriber, value => !!value && subscriber.next(value)));
  });
}
